"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { key: 0 };
const _hoisted_3 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "bg-mutedpurple-800 h-16 sm:h-[7.5rem]" }, null, -1);
const _hoisted_4 = { class: "flex justify-center px-5 pb-20" };
const _hoisted_5 = { class: "w-full max-w-[720px]" };
const _hoisted_6 = /*#__PURE__*/ (0, vue_2.createElementVNode)("h2", { class: "text-2xl md:text-6xl uppercase font-extrabold leading-squished tracking-tight mt-20 mb-5 text-center" }, " ¡Bien Hecho! ", -1);
const _hoisted_7 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "prose prose-lg max-w-none text-center" }, " You have completed the test. Your results are below, along with our recommended courses. ", -1);
const _hoisted_8 = { class: "my-8 p-5 rounded-3xl text-center bg-beige-100" };
const _hoisted_9 = /*#__PURE__*/ (0, vue_2.createElementVNode)("h3", { class: "uppercase tracking-widest font-semibold text-xxs mb-5" }, "Results", -1);
const _hoisted_10 = { class: "text-2xl md:text-6xl font-black tracking-tight leading-squished" };
const _hoisted_11 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "my-5 prose prose-lg max-w-none text-center" }, " We recommend that you take a course at the following level: ", -1);
const _hoisted_12 = { class: "my-5 uppercase tracking-tighter font-black text-2xl" };
const _hoisted_13 = ["href"];
const _hoisted_14 = { class: "mt-10 mb-20" };
const _hoisted_15 = /*#__PURE__*/ (0, vue_2.createElementVNode)("h3", { class: "uppercase tracking-widest font-semibold text-xxs mb-5 text-center" }, " Share results ", -1);
const _hoisted_16 = { class: "w-[60px] h-[60px] rounded-full border-2 border-mutedpurple-800 flex justify-center items-center" };
const _hoisted_17 = { class: "w-[60px] h-[60px] rounded-full border-2 border-mutedpurple-800 flex justify-center items-center" };
const _hoisted_18 = { class: "w-[60px] h-[60px] rounded-full border-2 border-mutedpurple-800 flex justify-center items-center" };
const _hoisted_19 = { key: 1 };
const _hoisted_20 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "bg-mutedpurple-800 h-16 sm:h-[7.5rem]" }, null, -1);
const _hoisted_21 = { class: "flex justify-center px-5 pb-20" };
const _hoisted_22 = { class: "w-full max-w-screen-md" };
const _hoisted_23 = /*#__PURE__*/ (0, vue_2.createElementVNode)("h2", { class: "text-2xl md:text-6xl uppercase font-extrabold leading-squished mt-20 mb-5 text-center" }, " Get your results ", -1);
const _hoisted_24 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "prose prose-lg max-w-none" }, " Become part of the community and stay up todate with everything going on at Battersea Spanish. ", -1);
const _hoisted_25 = ["onSubmit"];
const _hoisted_26 = { class: "grid grid-cols-1 md:grid-cols-2 gap-5 my-5" };
const _hoisted_27 = /*#__PURE__*/ (0, vue_2.createElementVNode)("label", {
    for: "testLastName",
    class: "label block",
    placeholder: "Name..."
}, " First name ", -1);
const _hoisted_28 = /*#__PURE__*/ (0, vue_2.createElementVNode)("label", {
    for: "testLastName",
    class: "label block",
    placeholder: "Last Name.."
}, " Last name ", -1);
const _hoisted_29 = { class: "grid grid-cols-1 md:grid-cols-2 gap-5 my-5" };
const _hoisted_30 = /*#__PURE__*/ (0, vue_2.createElementVNode)("label", {
    for: "testEmail",
    class: "label block",
    placeholder: "Email Address..."
}, " Email ", -1);
const _hoisted_31 = /*#__PURE__*/ (0, vue_2.createElementVNode)("label", {
    for: "testPhone",
    class: "label block",
    placeholder: "Phone number (optional)..."
}, " Phone (optional) ", -1);
const _hoisted_32 = { class: "grid grid-cols-1 gap-5 my-5" };
const _hoisted_33 = /*#__PURE__*/ (0, vue_2.createElementVNode)("label", {
    for: "testPhone",
    class: "label block",
    placeholder: "Phone number (optional)..."
}, " Education History ", -1);
const _hoisted_34 = { class: "grid grid-cols-2" };
const _hoisted_35 = ["id", "name", "value"];
const _hoisted_36 = ["for"];
const _hoisted_37 = {
    key: 0,
    class: "my-5"
};
const _hoisted_38 = {
    for: "testWhatsapp",
    class: "label flex items-center"
};
const _hoisted_39 = /*#__PURE__*/ (0, vue_2.createTextVNode)(" Contact me on WhatsApp ");
const _hoisted_40 = ["disabled"];
const _hoisted_41 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "Get my results", -1);
const _hoisted_42 = {
    key: 2,
    class: "bg-mutedpurple-800 text-white md:grid md:grid-cols-2 flex flex-col-reverse"
};
const _hoisted_43 = { class: "pb-20 pt-32 md:pt-44 flex justify-end items-center px-10 md:px-20" };
const _hoisted_44 = { class: "max-w-[560px]" };
const _hoisted_45 = /*#__PURE__*/ (0, vue_2.createElementVNode)("h1", null, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "font-script text-6xl text-yellow-500 block mb-[-0.2em]" }, "Free"),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("span", { class: "font-sans text-6xl font-extrabold text-beige-200 uppercase" }, "spanish test")
], -1);
const _hoisted_46 = { class: "text-lg" };
const _hoisted_47 = { class: "flex gap-2 md:gap-5 md:flex-wrap" };
const _hoisted_48 = ["onClick"];
const _hoisted_49 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "Start Test", -1);
const _hoisted_50 = ["href"];
const _hoisted_51 = /*#__PURE__*/ (0, vue_2.createElementVNode)("span", null, "Our Courses", -1);
const _hoisted_52 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "relative" }, [
    /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "absolute left-0 top-0 w-full h-[7.5rem] bg-gradient-to-b from-black via-black to-transparent opacity-40 z-20" }),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("img", {
        src: "/img/spanish-class-26.jpg",
        alt: "",
        class: "md:absolute md:top-0 md:left-0 md:w-full md:h-full md:object-cover z-10"
    })
], -1);
const _hoisted_53 = { key: 3 };
const _hoisted_54 = /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "bg-mutedpurple-800 h-16 sm:h-[7.5rem]" }, null, -1);
const _hoisted_55 = { class: "flex justify-center px-5 pb-20" };
const _hoisted_56 = { class: "w-full max-w-screen-xl" };
const vue_3 = require("vue");
const ProficiencyTest_1 = require("../../stores/ProficiencyTest");
const pinia_1 = require("pinia");
const vue_4 = require("vue");
const ProficiencyTestSection_vue_1 = __importDefault(require("./ProficiencyTestSection.vue"));
const ProficiencyTestNav_vue_1 = __importDefault(require("./ProficiencyTestNav.vue"));
const ButtonIcon_vue_1 = __importDefault(require("../ButtonIcon.vue"));
const SvgSprite_vue_1 = __importDefault(require("../../vendor/enso/components/SvgSprite.vue"));
const ShareLinks_vue_1 = __importDefault(require("../sharelinks/ShareLinks.vue"));
const Route_1 = __importDefault(require("../../src/Route"));
const Alerts_1 = require("../../stores/Alerts");
const AlertType_1 = require("../../src/types/AlertType");
exports.default = (0, vue_1.defineComponent)({
    __name: 'ProficiencyTest',
    props: {
        testSlug: {
            type: String,
            required: true,
        },
        historyOptions: {
            type: Array,
            required: true,
        },
    },
    setup(__props) {
        const props = __props;
        const store = (0, ProficiencyTest_1.useProficiencyTestStore)();
        const { complete, detailsProvided, test, currentSectionIndex, currentQuestionIndex } = (0, pinia_1.storeToRefs)(store);
        const loading = (0, vue_4.ref)(true);
        const sendingResults = (0, vue_4.ref)(false);
        const alertStore = (0, Alerts_1.useAlertsStore)();
        store.$state.submission.test = props.testSlug;
        store.getTest(props.testSlug).then(() => {
            loading.value = false;
        });
        const coursesUrl = (0, vue_3.computed)(() => {
            if (!store.recommendCategory) {
                return '';
            }
            return (0, Route_1.default)('whats-on.index', {
                category: store.recommendedCategory.slug,
            });
        });
        function start() {
            currentSectionIndex.value = 0;
            currentQuestionIndex.value = 0;
        }
        function onSubmitDetails() {
            sendingResults.value = true;
            store
                .submitTest()
                .catch((err) => {
                var _a, _b;
                let message = err.message;
                console.error(err);
                // If message exists get it
                if (((_b = (_a = err === null || err === void 0 ? void 0 : err.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.errors) && Object.keys(err.response.data.errors).length > 0) {
                    message = Object.values(err.response.data.errors)[0];
                    message = message[0];
                }
                alertStore.add({
                    type: AlertType_1.AlertType.Error,
                    message: message,
                    key: 'proficiency-test',
                });
            })
                .then(() => {
                sendingResults.value = false;
            });
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                (loading.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, "Loading..."))
                    : (0, vue_2.createCommentVNode)("", true),
                ((0, vue_2.unref)(test))
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, { key: 1 }, [
                        ((0, vue_2.unref)(detailsProvided))
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_2, [
                                _hoisted_3,
                                (0, vue_2.createVNode)(ProficiencyTestNav_vue_1.default, {
                                    sections: (0, vue_2.unref)(test).sections,
                                    "current-section": (0, vue_2.unref)(store).currentSection
                                }, null, 8, ["sections", "current-section"]),
                                (0, vue_2.createElementVNode)("div", _hoisted_4, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_5, [
                                        _hoisted_6,
                                        _hoisted_7,
                                        (0, vue_2.createElementVNode)("div", _hoisted_8, [
                                            _hoisted_9,
                                            (0, vue_2.createElementVNode)("div", _hoisted_10, (0, vue_2.toDisplayString)((0, vue_2.unref)(store).finalCorrectAnswerCount) + "/" + (0, vue_2.toDisplayString)((0, vue_2.unref)(store).totalQuestions), 1),
                                            _hoisted_11,
                                            (0, vue_2.createElementVNode)("div", _hoisted_12, (0, vue_2.toDisplayString)((0, vue_2.unref)(store).recommendedCategory.name), 1),
                                            (0, vue_2.createElementVNode)("a", {
                                                href: (0, vue_2.unref)(coursesUrl),
                                                class: "button button-outlined button-mutedpurple-800 has-icon"
                                            }, [
                                                (0, vue_2.createVNode)(ButtonIcon_vue_1.default),
                                                (0, vue_2.createElementVNode)("span", null, "View " + (0, vue_2.toDisplayString)((0, vue_2.unref)(store).recommendedCategory.name) + " Courses", 1)
                                            ], 8, _hoisted_13)
                                        ]),
                                        (0, vue_2.createElementVNode)("div", _hoisted_14, [
                                            _hoisted_15,
                                            (0, vue_2.createVNode)(ShareLinks_vue_1.default, {
                                                platforms: ['facebook', 'twitter', 'email'],
                                                class: "flex justify-center gap-5"
                                            }, {
                                                facebook: (0, vue_2.withCtx)(() => [
                                                    (0, vue_2.createElementVNode)("div", _hoisted_16, [
                                                        (0, vue_2.createVNode)(SvgSprite_vue_1.default, {
                                                            href: "icon-facebook",
                                                            class: "w-8 h-8"
                                                        })
                                                    ])
                                                ]),
                                                twitter: (0, vue_2.withCtx)(() => [
                                                    (0, vue_2.createElementVNode)("div", _hoisted_17, [
                                                        (0, vue_2.createVNode)(SvgSprite_vue_1.default, {
                                                            href: "icon-twitter",
                                                            class: "w-8 h-8"
                                                        })
                                                    ])
                                                ]),
                                                email: (0, vue_2.withCtx)(() => [
                                                    (0, vue_2.createElementVNode)("div", _hoisted_18, [
                                                        (0, vue_2.createVNode)(SvgSprite_vue_1.default, {
                                                            href: "icon-envelope",
                                                            class: "w-8 h-8"
                                                        })
                                                    ])
                                                ]),
                                                _: 1
                                            })
                                        ])
                                    ])
                                ])
                            ]))
                            : ((0, vue_2.unref)(complete))
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_19, [
                                    _hoisted_20,
                                    (0, vue_2.createVNode)(ProficiencyTestNav_vue_1.default, {
                                        sections: (0, vue_2.unref)(test).sections,
                                        "current-section": (0, vue_2.unref)(store).currentSection
                                    }, null, 8, ["sections", "current-section"]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_21, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_22, [
                                            _hoisted_23,
                                            _hoisted_24,
                                            (0, vue_2.createElementVNode)("form", {
                                                action: "#",
                                                onSubmit: (0, vue_2.withModifiers)(onSubmitDetails, ["prevent"]),
                                                class: "my-5"
                                            }, [
                                                (0, vue_2.createElementVNode)("div", _hoisted_26, [
                                                    (0, vue_2.createElementVNode)("div", null, [
                                                        _hoisted_27,
                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                            id: "testFirstName",
                                                            type: "text",
                                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (((0, vue_2.unref)(store).submission.first_name) = $event)),
                                                            class: "input w-full",
                                                            placeholder: "Name...",
                                                            required: ""
                                                        }, null, 512), [
                                                            [vue_2.vModelText, (0, vue_2.unref)(store).submission.first_name]
                                                        ])
                                                    ]),
                                                    (0, vue_2.createElementVNode)("div", null, [
                                                        _hoisted_28,
                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                            id: "testLastName",
                                                            type: "text",
                                                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (((0, vue_2.unref)(store).submission.last_name) = $event)),
                                                            class: "input w-full",
                                                            placeholder: "Last Name...",
                                                            required: ""
                                                        }, null, 512), [
                                                            [vue_2.vModelText, (0, vue_2.unref)(store).submission.last_name]
                                                        ])
                                                    ])
                                                ]),
                                                (0, vue_2.createElementVNode)("div", _hoisted_29, [
                                                    (0, vue_2.createElementVNode)("div", null, [
                                                        _hoisted_30,
                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                            id: "testEmail",
                                                            type: "email",
                                                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => (((0, vue_2.unref)(store).submission.email) = $event)),
                                                            class: "input w-full",
                                                            placeholder: "Email Address...",
                                                            required: ""
                                                        }, null, 512), [
                                                            [vue_2.vModelText, (0, vue_2.unref)(store).submission.email]
                                                        ])
                                                    ]),
                                                    (0, vue_2.createElementVNode)("div", null, [
                                                        _hoisted_31,
                                                        (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                            id: "testPhone",
                                                            type: "text",
                                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => (((0, vue_2.unref)(store).submission.phone) = $event)),
                                                            class: "input w-full",
                                                            placeholder: "Phone Number (optiona)..."
                                                        }, null, 512), [
                                                            [vue_2.vModelText, (0, vue_2.unref)(store).submission.phone]
                                                        ])
                                                    ])
                                                ]),
                                                (0, vue_2.createElementVNode)("div", _hoisted_32, [
                                                    (0, vue_2.createElementVNode)("div", null, [
                                                        _hoisted_33,
                                                        (0, vue_2.createElementVNode)("ul", _hoisted_34, [
                                                            ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(__props.historyOptions, (option, index) => {
                                                                return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("li", { key: index }, [
                                                                    (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                                        type: "checkbox",
                                                                        class: "checkbox",
                                                                        id: option.value,
                                                                        name: `history[${option.value}]`,
                                                                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => (((0, vue_2.unref)(store).submission.history) = $event)),
                                                                        value: option.value
                                                                    }, null, 8, _hoisted_35), [
                                                                        [vue_2.vModelCheckbox, (0, vue_2.unref)(store).submission.history]
                                                                    ]),
                                                                    (0, vue_2.createElementVNode)("label", {
                                                                        for: option.value
                                                                    }, (0, vue_2.toDisplayString)(option.name), 9, _hoisted_36)
                                                                ]));
                                                            }), 128))
                                                        ])
                                                    ])
                                                ]),
                                                ((0, vue_2.unref)(store).submission.phone)
                                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_37, [
                                                        (0, vue_2.createElementVNode)("label", _hoisted_38, [
                                                            (0, vue_2.withDirectives)((0, vue_2.createElementVNode)("input", {
                                                                class: "checkbox",
                                                                type: "checkbox",
                                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => (((0, vue_2.unref)(store).submission.allow_whatsapp) = $event)),
                                                                id: "testWhatsapp"
                                                            }, null, 512), [
                                                                [vue_2.vModelCheckbox, (0, vue_2.unref)(store).submission.allow_whatsapp]
                                                            ]),
                                                            _hoisted_39
                                                        ])
                                                    ]))
                                                    : (0, vue_2.createCommentVNode)("", true),
                                                (0, vue_2.createElementVNode)("div", null, [
                                                    (0, vue_2.createElementVNode)("button", {
                                                        type: "submit",
                                                        class: "button button-outlined button-mutedpurple-800 has-icon",
                                                        disabled: sendingResults.value
                                                    }, [
                                                        (0, vue_2.createVNode)(ButtonIcon_vue_1.default),
                                                        _hoisted_41
                                                    ], 8, _hoisted_40)
                                                ])
                                            ], 40, _hoisted_25)
                                        ])
                                    ])
                                ]))
                                : ((0, vue_2.unref)(currentSectionIndex) === null)
                                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_42, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_43, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_44, [
                                                _hoisted_45,
                                                (0, vue_2.createElementVNode)("p", _hoisted_46, [
                                                    (0, vue_2.renderSlot)(_ctx.$slots, "default")
                                                ]),
                                                (0, vue_2.createElementVNode)("div", _hoisted_47, [
                                                    (0, vue_2.createElementVNode)("button", {
                                                        type: "button",
                                                        onClick: (0, vue_2.withModifiers)(start, ["prevent"]),
                                                        class: "button button-outlined button-coral-400 hover:button-coral-600 hover:text-white has-icon"
                                                    }, [
                                                        (0, vue_2.createVNode)(ButtonIcon_vue_1.default),
                                                        _hoisted_49
                                                    ], 8, _hoisted_48),
                                                    (0, vue_2.createElementVNode)("a", {
                                                        href: (0, vue_2.unref)(Route_1.default)('whats-on.index', { type: 'course' }),
                                                        class: "button button-outlined button-yellow-500 hover:button-yellow-700 hover:text-white has-icon"
                                                    }, [
                                                        (0, vue_2.createVNode)(ButtonIcon_vue_1.default),
                                                        _hoisted_51
                                                    ], 8, _hoisted_50)
                                                ])
                                            ])
                                        ]),
                                        _hoisted_52
                                    ]))
                                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_53, [
                                        _hoisted_54,
                                        (0, vue_2.createVNode)(ProficiencyTestNav_vue_1.default, {
                                            sections: (0, vue_2.unref)(test).sections,
                                            "current-section": (0, vue_2.unref)(store).currentSection
                                        }, null, 8, ["sections", "current-section"]),
                                        (0, vue_2.createElementVNode)("div", _hoisted_55, [
                                            (0, vue_2.createElementVNode)("div", _hoisted_56, [
                                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)((0, vue_2.unref)(test).sections, (section, index) => {
                                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)(vue_2.Fragment, null, [
                                                        (index === (0, vue_2.unref)(currentSectionIndex))
                                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(ProficiencyTestSection_vue_1.default, {
                                                                key: 0,
                                                                section: section,
                                                                "last-section": index === (0, vue_2.unref)(test).sections.length - 1
                                                            }, null, 8, ["section", "last-section"]))
                                                            : (0, vue_2.createCommentVNode)("", true)
                                                    ], 64));
                                                }), 256))
                                            ])
                                        ])
                                    ]))
                    ], 64))
                    : (0, vue_2.createCommentVNode)("", true)
            ], 64));
        };
    }
});
